import React, { useEffect, useState } from 'react';
import { Grid, Box, Container, Typography, Skeleton, Card, CardContent } from '@mui/material';
import ProjectCard from '../components/ProjectCard';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Helmet } from "react-helmet";
const Projects = () => {
    const [project, setProject] = useState([])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_MY_API}/api/projects`,

        }).then((res) => {
            setTimeout(() => {
                setProject(res.data.data); // your API response
                setLoading(false);
            }, 2000);
        }).catch((err) => {
            console.warn(err)
        })
    }, [])
    return (
        <>
            <Helmet>
                <title>Completed Painting Projects | PM Painters Portfolio</title>
                <meta name="description" content="Browse our portfolio of successfully completed home and commercial painting projects across India. Quality work, on-time delivery." />
                <meta name="keywords" content="painting project gallery, PM Painters projects, home painting portfolio, commercial painting work" />
            </Helmet>


            <Box sx={{ width: '100%' }}>
                <Container sx={{ mt: 2 }} maxWidth={false}>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true }}
                    >
                        <Typography variant="h4" gutterBottom align="center">
                            Our Projects
                        </Typography>
                    </motion.div>

                    <Grid container spacing={2} justifyContent="center">
                        {loading
                            ? Array.from(new Array(6)).map((_, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index} display="flex" justifyContent="center">
                                    <Card sx={{ width: '100%', maxWidth: 345 }}>
                                        <Skeleton variant="rectangular" width={210} height={118} />
                                        <CardContent>
                                            <Skeleton height={28} width="80%" />
                                            <Skeleton height={20} width="60%" />
                                            <Skeleton height={28} width="80%" />
                                            <Skeleton height={20} width="60%" />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))
                            : project.map((project) => (
                                <Grid item xs={12} sm={6} md={4} key={project.id}>
                                    <ProjectCard project={project} />
                                </Grid>
                            ))}
                    </Grid>
                </Container>
            </Box>
        </>

    );
};




export default Projects;
